function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocSightseeing2Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4c-4.963 0-9 4.037-9 9 0 5.457 6.81 12.5 9 14.623C18.19 25.5 25 18.457 25 13c0-4.962-4.037-9-9-9zm0 26a1 1 0 01-.67-.258C14.91 29.363 5 20.36 5 13 5 6.935 9.935 2 16 2s11 4.936 11 11c0 7.36-9.91 16.363-10.331 16.744a1 1 0 01-.67.257z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.636 11.481l-2.98-.41-1.272-2.822a.42.42 0 00-.768 0l-1.271 2.822-2.98.41a.423.423 0 00-.24.719l2.197 2.194-.55 3.11a.422.422 0 00.624.44L16 16.447l2.604 1.497a.422.422 0 00.625-.44l-.551-3.11 2.198-2.194a.424.424 0 00-.24-.719z",
    fill: props.color
  }));
}

export default SvgIconPocSightseeing2Filled;